var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQ5A(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 251,
    viewBox: "0 0 251 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M221.16 121.534V158.244C190.7 175.894 154.32 200.074 123.86 217.714L124.04 175.634C154.63 161.824 190.58 135.354 221.16 121.524V121.534Z",
    fill: "#72D09A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.96 108.575L28.46 117.945L76.25 91.7446C86.02 105.685 95.78 119.625 105.53 133.575C115.41 147.715 125.28 161.875 135.14 176.035C167.77 158.355 200.4 140.685 233.03 123.005C167.85 33.1846 237.7 128.935 167.85 33.1846L76.25 72.6546L21.96 108.575Z",
    fill: "#FECECA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8298 108.705L28.4698 117.935L76.2598 91.7348L124.05 176.035H135.15L76.2498 72.6748L21.8198 108.705H21.8298Z",
    fill: "#FEE4E2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.46 117.934L124.04 176.024L74.2 88.3145L28.46 117.934Z",
    fill: "#F97E73"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.2402 86.7451L86.8502 125.415H95.7002L97.1402 128.395H87.8902L97.9702 157.105L95.2602 158.555L67.2102 128.395L44.4902 127.715L54.2302 114.445L43.7002 103.135L46.1002 101.175L56.1102 111.935L74.2202 86.7451H74.2402ZM56.3902 116.765L49.8902 125.415H64.4402L56.3902 116.765ZM68.6602 125.415L58.2702 114.255L73.1302 93.7151L83.4902 125.415H68.6602ZM71.4402 128.395L92.5002 151.025L84.5502 128.395H71.4402Z",
    fill: "#FEE4E2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4797 117.935L124.07 176.035L123.86 217.735L29.2997 154.385L28.4697 117.935H28.4797Z",
    fill: "#B2E8C5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9301 110.125C21.4401 112.725 24.9501 115.335 28.4601 117.935L74.2101 88.3248L124.04 176.035H135.14L76.2401 72.6748C56.8001 85.1548 37.3602 97.6448 17.9102 110.125H17.9301Z",
    fill: "#FEE4E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ5A);
export default __webpack_public_path__ + "static/media/q5a.7c9a25fdfa97cf73e271f4eecf6d04ca.svg";
export { ForwardRef as ReactComponent };